<vl-spinner id="application" [show]="spinnerVisible"></vl-spinner>
<mat-sidenav-container class="sidebar-container-with-toolbar" >
    <mat-sidenav-content class="application-container">
        <div class="mat-container p-0">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb rounded-0 builder-breadcrumb">
                        <ng-container *ngFor="let crumb of breadcrumbs$ | async; let last = last; let i = index">
                            <ng-container *ngIf="!last">
                              <li (click)="onClickBreadcrumb(crumb, i)" class="breadcrumb-item inactive">{{capitalizeWords(crumb.label)}}</li>
                            </ng-container>
                            <ng-container *ngIf="last">
                                <li (click)="onClickBreadcrumb(crumb, i)" class="breadcrumb-item active">
                                    {{capitalizeWords(crumb.label) }}
                                </li>
                            </ng-container>
                        </ng-container>
                    </ol>
                  </nav>
            <div class="page-header">
                <div class="header-start">
                    <h2 class="title">{{projectName}}</h2>
                </div>
    
            </div>
            @if(([appPermissions.webApplication , permissionsActions.edit] | apppermissions) || ([appPermissions.mobileApplication , permissionsActions.edit] | apppermissions) ){
            <div class="container-fluid">
                <div class="row" *ngIf="!spinnerVisible">
                    <div class="col-sm-6 col-xl-3" *ngIf="[appPermissions.webApplication,permissionsActions.edit] | apppermissions">
                        <mat-card mat-ripple class="mat-custom-card mat-card-device desktop" (click)="createWebApplicationDialog()">
                            <div class="mat-card-device-header">
                                <div class="app-logo">
                                    <img *ngIf="webAppExists" [src]="webLogo + '?cache=' + lastModifyDate" alt="wenlogo">
                                    <mat-icon *ngIf="!webAppExists">add</mat-icon>
                                </div>
                                {{ webApp?.application_name || "Web App" }}
                            </div>
                            <mat-card-content>
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <div class="col-sm-6 col-xl-3" *ngIf="[appPermissions.mobileApplication,permissionsActions.edit] | apppermissions">
                        <mat-card mat-ripple class="mat-custom-card mat-card-device mobile"
                            (click)="createMobileApplicationDialog()">
                            <div class="mat-card-device-header">
                                <div class="app-logo"><img *ngIf="mobileAppExists" [src]="mobileLogo" alt="mobileLogo">
                                    <mat-icon *ngIf="!mobileAppExists">add</mat-icon>
                                </div>
                                {{ MobileApp.application_name ||"Mobile App"}}
                            </div>
                        </mat-card>
                    </div>
                </div>
            </div>
        }@else {
            <div class="container-fluid">
                <div class="no-permission-message message-container">
                    {{"You don't have permissions to view or create applications"}}
                </div>
            </div>
        }
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>